const MainRoutes = {
  path: "/main",
  meta: {
    requiresAuth: true,
  },
  redirect: "/main",
  component: () => import("@/layouts/full/FullLayout.vue"),
  children: [
    {
      name: "Dashboard",
      path: "/",
      component: () => import("@/views/StarterPage.vue"),
    },
    {
      name: "Sample Page 2",
      path: "/samplepage",
      component: () => import("@/views/Samplepage.vue"),
    },
    {
      name: "Proveedores",
      path: "/suppliers",
      component: () => import("@/views/SupplierPage.vue"),
    },
    {
      name: "Partidas Presupuestarias",
      path: "/budget-items",
      component: () => import("@/views/BudgetItemPage.vue"),
    },
    {
      name: "Activos Públicos",
      path: "/public-assets",
      component: () => import("@/views/public-assets/CostCenterPage.vue"),
    },
    {
      name: "Tipos de Activos Públicos",
      path: "/public-assets-types",
      component: () => import("@/views/public-assets/CostCenterType.vue"),
    },
    {
      name: "Subtipos de Activos Públicos",
      path: "/public-assets-subtypes",
      component: () => import("@/views/public-assets/CostCenterSubType.vue"),
    },
    {
      name: "Gestión de Obras",
      path: "/work-orders",
      component: () => import("@/views/works/WorkOrderPage.vue"),
    },
    {
      name: "Detalles de Obra",
      path: "/work-orders/:id",
      component: () => import("@/views/works/WorkOrderDetailView.vue"),
    },
    {
      name: "Gestión de Mantenimiento General",
      path: "/maintenance",
      component: () => import("@/views/works/WorkOrderManitenancePage.vue"),
    },
    {
      name: "Detalles de Mantenimiento",
      path: "/maintenance/:id",
      component: () => import("@/views/works/WorkOrderDetailView.vue"),
    },
    {
      name: "Gestión de Solicitudes",
      path: "/work-requests",
      component: () => import("@/views/work-request/WorkRequestPage.vue"),
    },
    {
      name: "Gestión de Autorización de Solicitudes",
      path: "/work-requests-authorization",
      component: () => import("@/views/work-request/WorkRequestAuthorizationPage.vue"),
    },
    {
      name: "Detalles de Solicitud",
      path: "/work-requests/:id",
      component: () => import("@/views/work-request/WorkRequestDetailPage.vue"),
    },
    {
      name: "Gestión de Facturas",
      path: "/invoices",
      component: () => import("@/views/invoices/InvoicesPage.vue"),
    },
      {
      name: "Gestión de Facturas Pendientes",
      path: "/invoices-pending",
      component: () => import("@/views/invoices/InvoicesPendingPage.vue"),
    }, {
      name: "Gestión de Facturas Enviadas",
      path: "/invoices-send",
      component: () => import("@/views/invoices/InvoicesSendPage.vue"),
    },
      {
      name: "Gestión de Facturas Listas",
      path: "/invoices-ready",
      component: () => import("@/views/invoices/InvoicesApprovedPage.vue"),
    },{
      name: "Gestión de Facturas Pago Listo",
      path: "/invoices-pago-listo",
      component: () => import("@/views/invoices/InvoicesPagoListoPage.vue"),
    },{
      name: "Gestión de Facturas Para Autorizar",
      path: "/invoices-authorization",
      component: () => import("@/views/invoices/InvoiceAuthorizationPage.vue")
    },
    {
      name: "Detalle del Presupuesto",
      path: "/purchase-budget/:id",
      component: () => import("@/views/PurchaseBudgetDetailPage.vue"),
    },
    {
      name: "Mi Perfil",
      path: "/profile",
      component: () => import("@/views/profile/ProfilePage.vue"),
    },
    {
      name: "Ordenes de Pago",
      path: "/payment-orders",
      component: () => import("@/views/payment-orders/PaymentOrdersPage.vue"),
    },
    {
      name: "Órdenes de Compra",
      path: "/purchase-orders",
      component: () => import("@/views/purchase-orders/PurchaseOrdersPage.vue"),
    },
    {
      name: "Dashboard de Partidas Presupuestarias",
      path: "/budget-items-dashboard",
      component: () => import("@/views/dashboards/BudgetItemsPage.vue"),
    },
    {
      name: "Dashboard de Activos Públicos",
      path: "/asset-expenditure-dashboard",
      component: () => import("@/views/dashboards/AssetExpenditurePage.vue"),
    },
    {
      name: "Dashboard de Órdenes de Trabajo",
      path: "/work-orders-summary-dashboard",
      component: () => import("@/views/dashboards/WorkOrdersSummaryPage.vue"),
    },
    {
      name: "Gestión de Suministros",
      path: "/supplies-management",
      component: () => import("@/views/supplies/SuppliesManagementPage.vue"),
    },
    {
      name: "Detalle de Suministro",
      path: "/supplies-management/:id",
      component: () => import("@/views/supplies/SupplyDetailPage.vue"),
    },
    {
      name: "Reportes de Servicios",
      path: "/services",
      component: () => import("@/views/services/ServicesPage.vue"),
    },
    {
      name: "Detalle de Informe de Servicio",
      path: "/services/:id",
      component: () => import("@/views/services/ServiceDetailPage.vue"),
    },
    {
      name: "Items de Catálogo",
      path: "/catalog-items",
      component: () => import("@/views/catalog-items/CatalogItemsPage.vue"),
    },
    {
      name: "Herramientas Administrativas",
      path: "/admin-tools",
      component: () => import("@/views/admin/AdminToolsPage.vue"),
      meta: { requiresAuth: true, roles: ['ROOT'] },
    },
    {
      name: "Permisos de Endpoints",
      path: "/endpoint-permissions",
      component: () => import("@/views/admin/EndpointPermissionsPage.vue"),
      meta: { requiresAuth: true, roles: ['ROOT'] },
    },
  ],
};

export default MainRoutes;
